var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "team-drawal" }, [
      _c("div", { staticClass: "table-title" }, [_vm._v("WITHDRAWALS")]),
      _c("div", { staticClass: "payment-table" }, [
        _c("div", { staticClass: "table-header" }, [
          _c("div", { staticClass: "table-head" }, [_vm._v("Amount")]),
          _c("div", { staticClass: "table-head" }, [_vm._v("Date")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }